import React from 'react';
import type { AccessibilityProps, ImageSourcePropType } from 'react-native';
import { Image, StyleSheet } from 'react-native';

import { useResponsive } from '../../../../../hooks';
import { theme } from '@garnish/constants';

// ─────────────────────────────────────────────────────────────────────────────

export const PageHeroHeaderImg = (props: PageHeroHeaderImgProps) => {
  const { source, accessibilityLabel } = props;

  const { match } = useResponsive();

  const imgResponsiveStyles = match([
    styles.imgXS,
    styles.imgSM,
    styles.imgSM,
    styles.imgLG,
  ]);
  const imgStyles = [styles.img, imgResponsiveStyles];

  return (
    <Image
      source={source}
      style={imgStyles}
      accessibilityLabel={accessibilityLabel}
      accessibilityIgnoresInvertColors
      resizeMode="contain"
    />
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  img: {
    maxWidth: '100%',
  },
  imgXS: {
    width: 350,
    height: 180,
    marginBottom: theme.spacing['10'],
  },
  imgSM: {
    width: 510,
    height: 270,
    marginBottom: theme.spacing['10'],
  },
  imgLG: {
    width: 700,
    height: 362,
    marginBottom: theme.spacing['20'],
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type PageHeroHeaderImgProps = {
  readonly source: ImageSourcePropType;
  readonly accessibilityLabel?: AccessibilityProps['accessibilityLabel'];
};
